import React from 'react';
import { ADMIN_QUALITY_GRADES, getAdminQualityGrade } from '../../helpers/product_mention_helpers';
import './ProductMentionScorePanel.scss';

const ProductMentionScorePanel = props => {
  const { qualityScore, adminQualityScore, isScoring, isSavingQualityScore, onScore, onHumanScore } = props;
  const modelGrade = getAdminQualityGrade(qualityScore);

  return (
    <div className='product-mention-score-panel'>
      <div className='pmsp-model'>
        <span className='pmsp-model-label'>Model</span>
        <span className='pmsp-model-value'>{modelGrade ? modelGrade.label : '—'}</span>
        {!modelGrade && (
          <button type='button' className='pmsp-run' disabled={isScoring} onClick={onScore}>
            {isScoring ? 'Scoring…' : 'Score'}
          </button>
        )}
      </div>

      <label className='pmd-label' htmlFor='mention-quality-score'>Override score</label>
      <select id='mention-quality-score' disabled={isSavingQualityScore} value={adminQualityScore ?? ''} onChange={e => onHumanScore(e.target.value === '' ? null : Number(e.target.value))}>
        <option value=''>{modelGrade ? 'Keep model grade' : 'None'}</option>
        {ADMIN_QUALITY_GRADES.map(({ value, label, title }) => (
          <option key={value} value={value}>
            {label} — {title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProductMentionScorePanel;
